/* eslint-disable @typescript-eslint/no-explicit-any */
/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init';
/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 * 1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 * 2. Application imports. Files imported here are loaded once the browser polyfills are loaded.
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

/**
 * If you need to support Internet Explorer, add the following import.
 */
import 'core-js/es/array';
import 'core-js/es/date';
import 'core-js/es/function';
import 'core-js/es/map';
import 'core-js/es/math';
import 'core-js/es/number';
import 'core-js/es/object';
import 'core-js/es/promise';
import 'core-js/es/reflect';
import 'core-js/es/regexp';
import 'core-js/es/set';
import 'core-js/es/string';
import 'core-js/es/symbol';
import 'core-js/es/weak-map';
import 'core-js/es/array-buffer';
import 'core-js/es/data-view';
import 'core-js/es/typed-array';

/** IE10 and IE11 requires the following for NgClass support on SVG elements */
import 'classlist.js'; // Run `npm install --save classlist.js`.

/**
 * Web Animations `@angular/platform-browser/animations`
 * Required for animation support in Angular.
 */
import 'web-animations-js';  // Run `npm install --save web-animations-js`.

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js';  // Included with Angular CLI.

/***************************************************************************************************
 * APPLICATION IMPORTS
 */

import 'event-source-polyfill';

// Algolia : https://github.com/algolia/algoliasearch-client-javascript/issues/691
(window as any).process = {
    env: { DEBUG: undefined },
};

// Socketio: https://github.com/socketio/socket.io-client/issues/1166#issuecomment-386195105
// Mapbox GL: https://github.com/Wykks/ngx-mapbox-gl/issues/136#issuecomment-496224634
(window as any).global = window;

// https://github.com/auth0/angular2-jwt/issues/674
import 'url-polyfill';
